import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    overlayActive: false,
    div_proc_vis: false,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
